import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-document-date-dialog',
  templateUrl: './document-date-dialog.component.html',
  styleUrls: ['./document-date-dialog.component.scss']
})
export class DocumentDateDialogComponent implements OnInit {
  renewalDate: Date | null = null;
  dueDate: Date | null = null;

  constructor(
    public dialogRef: MatDialogRef<DocumentDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedTitle: string }
  ) {
  }

  ngOnInit() {
  }

  submit() {
    this.dialogRef.close({
      renewalDate: this.renewalDate,
      dueDate: this.dueDate
    });
  }
}
